import {
    DeleteOutlined,
    DownOutlined,
    EditFilled,
    PlusCircleFilled,
} from '@ant-design/icons'
import {
    Button,
    Col,
    Input,
    InputNumber,
    Row,
    Tree,
    TreeProps,
    Typography,
} from 'antd'
import { DataNode } from 'antd/lib/tree'
import React, { useEffect, useState } from 'react'
import { randomId } from '../../pages/utils'
import { BiCheck } from 'react-icons/bi'
const defaultKeys = ['fareShortage', 'late', 'deductions']

interface PayrollDeductionsProps {
    onChange: (data: any) => void
    data: any[]
}
function PayrollDeductions({ onChange, data }: PayrollDeductionsProps) {
    const [deductions, setDeductions] = useState<any[]>(data)
    const [currentEditing, setCurrentEditing] = useState<any | undefined>(
        undefined
    )
    const [defaultData, setDefault] = useState<DataNode[]>([
        {
            title: 'Deduction',
            key: 'deductions',
            children: [
                {
                    title: 'SSS',
                    key: 'sssDeduction',
                    // @ts-ignore
                    data: 473,
                },
                {
                    title: 'Pag-IBIG',
                    key: 'pagibigDeductions',
                    // @ts-ignore
                    data: 100,
                },
                {
                    title: 'PhilHealth',
                    key: 'philhealthDeduction',
                    // @ts-ignore
                    data: 200,
                },
                //   {
                //     checkable: false,
                //     title: (
                //         <Button type='link' icon={<PlusCircleFilled />} onClick={handleNewDeductions}> New</Button>
                //     ),
                //     key: 'new',
                //   },
            ],
        },
    ])
    const handleDeleteDeductions = (key: string | number) => {
        // eslint-disable-next-line no-console
        // console.log(key, deductions)

        const newDeductions = [...deductions]
        const deductionIdx = newDeductions.findIndex(
            (deduction) => deduction.key === key
        )
        if (deductionIdx >= 0) {
            newDeductions.splice(deductionIdx, 1)
            setDeductions(newDeductions)
        }
    }
    const handleNewDeductions = () => {
        // const deductions = [...deductions]
        const id = randomId(5)
        setCurrentEditing({
            data: 0,
            value: '',
            key: id,
            isEditing: true,
        })
        setDeductions([
            ...deductions,
            {
                title: '',
                data: 0,
                value: '',
                key: id,
                isEditing: true,
            },
        ])
    }
    const [expandedKeys, setExpandedKeys] = useState<any>(['deduction'])
    const onSelect: TreeProps['onCheck'] = (selectedKeys, info) => {
        // eslint-disable-next-line no-console
        // console.log('selected', selectedKeys, info)
        const key = info.node.key
        // @ts-ignore
        setExpandedKeys([...new Set([...expandedKeys, ...selectedKeys])])
        // if(defaultKeys.includes(key as string)) return
        let newDeductions = [...deductions]
        const idx = newDeductions.findIndex(
            (deduction) => deduction.key === key
        )
        if (idx >= 0) {
            let obj = {
                ...newDeductions[idx],
            }
            obj.isChecked = info.checked
            newDeductions[idx] = obj
            setDeductions(newDeductions)
        }
    }
    // eslint-disable-next-line no-console
    // console.log( deductions)
    const handleSave = (data: any) => {
        // eslint-disable-next-line no-console
        // console.log(data, deductions)
        let newDeductions = [...deductions]
        const idx = newDeductions.findIndex(
            (deduction) => deduction.key === data.key
        )
        if (idx >= 0) {
            let obj = {
                ...newDeductions[idx],
            }
            obj.title = data.value
            obj.isChecked = data.isChecked
            obj.value = data.value
            obj.data = data.data
            obj.isEditing = false
            newDeductions[idx] = obj
            setDeductions(newDeductions)
            setCurrentEditing(undefined)
        }
    }
    useEffect(() => {
        setDefault([
            {
                title: (
                    <Typography.Text style={{ fontWeight: 'bolder' }}>
                        Enable Deductions
                    </Typography.Text>
                ),
                key: 'deductions',
                children: [
                    ...deductions,
                    {
                        checkable: false,
                        title: (
                            <Button
                                type="link"
                                icon={<PlusCircleFilled />}
                                onClick={handleNewDeductions}
                            >
                                {' '}
                                New
                            </Button>
                        ),
                        data: 'wash',
                        key: 'new',
                    },
                ],
            },
        ])
        onChange(deductions)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deductions])

    useEffect(() => {
        const keys: any = ['deduction']
        data.forEach((datum) => {
            if (datum.isChecked) {
                keys.push(datum.key)
            }
        })
        setExpandedKeys(keys)
    }, [data])
    return (
        <Tree
            checkable
            showLine
            defaultExpandAll
            switcherIcon={<DownOutlined />}
            checkedKeys={expandedKeys}
            onCheck={onSelect}
            treeData={defaultData}
            titleRender={(node: any) => {
                const title: any = node.title

                if (
                    currentEditing &&
                    node.key === currentEditing.key &&
                    currentEditing.isEditing
                ) {
                    return (
                        <Row
                            key={node.key}
                            align={'middle'}
                            wrap={false}
                            gutter={[12, 12]}
                            onClick={function (e) {
                                e.stopPropagation()
                                e.preventDefault()
                            }}
                        >
                            <Col>
                                <Input
                                    placeholder={'Title'}
                                    value={currentEditing.value as string}
                                    onChange={(e) => {
                                        setCurrentEditing({
                                            ...currentEditing,
                                            value: e.target.value || '',
                                            title: e.target.value || '',
                                        })
                                    }}
                                />
                            </Col>
                            <Col>
                                <span style={{ fontSize: 24 }}>:</span>
                            </Col>
                            <Col>
                                <InputNumber
                                    placeholder={'Amount'}
                                    value={currentEditing.data as number}
                                    onFocus={function (e) {
                                        // @ts-ignore
                                        e.target.select()
                                        e.stopPropagation()
                                        e.preventDefault()
                                    }}
                                    onClick={function (e) {
                                        e.stopPropagation()
                                        e.preventDefault()
                                    }}
                                    onChange={(e) => {
                                        setCurrentEditing({
                                            ...currentEditing,
                                            data: e || 0,
                                        })
                                    }}
                                />
                            </Col>
                            <Col>
                                <Row wrap={false} gutter={[6, 6]}>
                                    <Col>
                                        <Button
                                            onClick={() =>
                                                handleSave(currentEditing)
                                            }
                                            type="primary"
                                            style={{
                                                padding: 0,
                                                backgroundColor: 'green',
                                            }}
                                            icon={<BiCheck />}
                                        />
                                        {/* <Button type='link' onClick={() => handleSave(currentEditing)} size='large'><BiCheck /></Button> */}
                                    </Col>
                                    <Col>
                                        <Button
                                            onClick={() =>
                                                handleDeleteDeductions(node.key)
                                            }
                                            danger
                                            type="primary"
                                            style={{ padding: 0 }}
                                            icon={<DeleteOutlined />}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    )
                }
                if (node.key === 'new') {
                    return (
                        <Button
                            type="link"
                            icon={<PlusCircleFilled />}
                            onClick={function (e) {
                                e.stopPropagation()
                                e.preventDefault()
                                handleNewDeductions()
                            }}
                        >
                            New
                        </Button>
                    )
                }
                if (defaultKeys.includes(node.key as string))
                    return (
                        <div
                            onClick={function (e) {
                                e.stopPropagation()
                                e.preventDefault()
                            }}
                        >
                            {title} {node.data ? ` : ₱${node.data}` : null}
                        </div>
                    )

                return (
                    <Row
                        onClick={function (e) {
                            e.stopPropagation()
                            e.preventDefault()
                        }}
                    >
                        <Col>
                            {node.value || node.key}{' '}
                            {node.data ? ` : ₱${node.data}` : null}
                        </Col>
                        <Col>
                            <Button
                                onClick={() =>
                                    // handleSave(currentEditing)
                                    setCurrentEditing({
                                        data: node.data,
                                        value: node.value,
                                        key: node.key,
                                        isEditing: true,
                                    })
                                }
                                type="link"
                                icon={<EditFilled />}
                            />
                        </Col>
                    </Row>
                )
            }}
        />
    )
}

export default PayrollDeductions
